import { useLazyQuery as b } from "@apollo/client";
import { useFrontendConfigContext as M } from "../../../config-lib/contexts/FrontendConfigContext.js";
import { currencyOffchainTokenSchema as O } from "../../deserialize/yup/currency.js";
import x from "../../graphql/query/getOffChainTokenBalances.js";
import * as t from "ramda";
import { useState as k, useCallback as u } from "react";
const v = () => {
  const { waitConfig: f } = M(), [d, { loading: y }] = b(x), [C, E] = k({}), [T, w] = k({}), g = u(
    (e, s) => t.reduce(
      (o, a) => {
        const n = t.prop(
          a,
          s
        );
        return t.concat(
          t.isNotNil(n) ? n.assets : [a],
          o
        );
      },
      [],
      e
    ),
    []
  ), h = u(
    (e, s, o) => {
      const a = t.prop(
        e,
        s
      ), n = t.filter(
        (r) => t.includes(r.assetName, (a == null ? void 0 : a.assets) || []),
        o
      );
      if (t.isNotEmpty(n))
        return n;
      const i = t.find((r) => r.assetName === e, o);
      return t.isNotNil(i) ? [i] : [];
    },
    []
  ), N = u((e) => {
    let s = BigInt(0);
    return t.forEach((o) => {
      s += BigInt(o.amount || "0");
    }, e), s.toString();
  }, []), B = u(async () => {
    const e = await f(), s = (e == null ? void 0 : e.supportToken.allTokens.offChain) || [], o = (e == null ? void 0 : e.relatedAsset) || {};
    if (t.isEmpty(s))
      return {
        grouped: {},
        flatten: {}
      };
    const a = g(s, o), n = await d({
      variables: {
        input: {
          rewardNames: a
        }
      }
    }), i = t.pathOr(
      [],
      ["data", "getClaimableRewardBalances"],
      n
    ), r = t.map(
      (c) => O.cast(c),
      i
    );
    let l = {};
    t.forEach((c) => {
      const m = h(c, o, r);
      if (t.isNotEmpty(m)) {
        const S = N(m), R = t.head(m);
        l = t.assoc(R.type, String(S), l);
      }
    }, s), E(l);
    let p = {};
    return t.forEach((c) => {
      p = t.assoc(c.type, String(c.amount || "0"), p);
    }, r), w(p), {
      grouped: l,
      flatten: p
    };
  }, [
    f,
    g,
    d,
    h,
    N
  ]);
  return {
    grouped: C,
    flatten: T,
    loading: y,
    fetch: B
  };
};
export {
  v as default
};
//# sourceMappingURL=useGetOffChainTokenBalances.js.map
